import { type ApiResponse } from 'tendril-v1/src/types/ApiResponse';
import routes from 'tendril-v1/src/constants/routes';
import axios from 'axios';
import { type SalesforceCallDisposition } from 'tendril-v2/src/Data/DataSource/sync/salesforce-mappings/dto/salesforce-custom-dispositions.dto';

export async function getSalesforceDispositions(
  organizationId: string,
  nonce: string,
): Promise<ApiResponse<SalesforceCallDisposition[]>> {
  try {
    const salesforceDispositionsUrl = `${String(
      routes.get.salesforce.getCustomDispositions,
    )}/${organizationId}/${nonce}`;

    const { data } = await axios.get<string[]>(salesforceDispositionsUrl);

    const returningData: SalesforceCallDisposition[] = data.map((disposition, index) => {
      return {
        id: String(index),
        attributes: {
          name: disposition,
          outcome: disposition,
        },
        type: 'callDisposition',
      };
    });

    return {
      success: true,
      data: returningData,
    };
  } catch {
    return {
      success: false,
      error: { message: 'An error occurred while retrieving hubspot call dispositions' },
    };
  }
}
